<template>
  <BaseCustomizeMetal componentCode="H" />
</template>
<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalH",
  components: {
    BaseCustomizeMetal,
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 77px;
    left: 95px;
    @include betweenTableTablePro {
      top: 50px;
      left: 47px;
    }
    @include table {
      top: 35px;
      left: 22px;
    }
    @include phone {
      top: 27px;
      left: 8px;
    }
  }
  .templeName {
    height: 33px;
    width: 301px;
    .textContainer {
      width: 301px;
    }
  }
  .godName {
    width: 301px;
    height: 62px;
    .textContainer {
      width: 301px;
    }
  }
  .gift {
    margin: 0 0 auto auto;
    width: 237px;
    height: 42px;
    .textContainer {
      width: 237px;
    }
  }
  .respect {
    position: absolute;
    bottom: 5px;
    left: 9px;
  }
}
</style>
